import utils from '@os-plugins/util.js';
import productsManage from '@os-plugins/cart/property';
import amendHelp from '@os-plugins/utils/amendHelp.js';
import amendProductFee from '@os-plugins/utils/amendProductFee.js';

var ORDER = 'this.state.booking.order'
var STORE = 'this.state.booking.store.data'

const isObj = (obj) => {
  return (typeof obj === 'object' || typeof obj === 'function') && obj !== null
}

const deepCopy = (obj, hash = new WeakMap()) => {
  if(hash.has(obj)) { return hash.get(obj) }
  let cloneObj = Array.isArray(obj) ? [] : {}
  if (isObj(obj) && obj.hasOwnProperty('_means')) {
    cloneObj._means = obj._means;
  }
  hash.set(obj, cloneObj);
  for (let key in obj) {
    if (isObj(obj[key]) && obj[key].hasOwnProperty('_means')) {
      if (cloneObj[key]) {
        cloneObj[key]._means = obj[key]._means;
      }
    }
    cloneObj[key] = isObj(obj[key]) ? deepCopy(obj[key], hash) : obj[key];
  }
  return cloneObj
}

export const state = () => ({
  /**
   * 分类+餐品的数量数据
   * 除了 total 外: 
   * key(大分类): "big-uid" 如 123
   * key(小分类): "big-uid"+ "-" +"small-uid" 如 123-456
   * key(餐品类): "big-uid"+ "-" +"small-uid"+ "-" + "product-uid" 如 123-456-789
   * value: 已选总数量
   * */
  count:{
    //大分类
    big:{},
    //小分类
    small:{},
    //餐品
    product:{},

    //总的餐品数量
    total:0,

    //需要餐盒费的数量
    mealFee:0
  } ,

  /**
   * 计费对象
   * */
  fee:{ 
    
    /**
     * 纯餐品费用
     * */
    products: 0,

    /**
     * 外送费
     * */
    delivery: 0,

    /**
     * 优惠券减免的金额 (0或正数)
     * */
    coupon: 0,

    /**
     * 优惠活动减免的金额 (0或正数)
     * */
    preferential: 0,

    /**
     * 茶位费
     * */
    tea: 0,

    /**
     * 餐盒费
     * */
    mealFee: 0,

    manualDiscount: 0, // 手动打折，如果有传改字段才会存在
    
    /**
     * 原订单的优惠金额
     */
    originOrderDiscount: 0,

    /**
     * 附加费金额
     * */
    surcharge: 0,

        /**
     * 附加费率
     * 通过餐单接口的 surchargeRate(附加费比率,百分之几) 计算得出
     * 需确认 是否 包含优惠券和优惠活动?????
     * */
    surchargeRate: 0,
    /**
     * 总费用
     * 以上所有费用的总和
     * */
    total: 0
  
  } ,

  mealFeeAmendShow: 0, // 新改单的餐盒费展示，未被手动输入框修改餐盒费污染的餐盒费

  //优惠券对象
  hasCoupon:false ,
  userCoupon:false ,
  coupon:{

  },

  //已选营销活动
  pres:[],

  //已选餐品 对象
  products:{},

  //处理后的餐品 数组
  _products:[],
  
  outMenuProducts: [],  // 容错餐品

  giveProducts: [],  // 赠送餐品

  //餐单id 用于判断是否需清空购物车
  menuId:0,

});

var _state = utils.clearObject(state());
var timer;

const computePrice = (price)=> utils.computePrice(price,2);
const computeProduct = (pro)=>{
  var totalPrice = 0;
  var totalMealFee = pro.mealFee * pro.num;
  var totalProductPrice = pro.price * pro.num;
  if (pro.isRequirement && pro.products.listRequirements) { // 计算特殊要求费用
    totalProductPrice = 0;
    let reqPrice = [];

    (pro._additional.list || []).map(item => {
      reqPrice.push(item.pricing * (item.num || 1))
    })

    // pro.products.listRequirements.forEach(
    //   (requirements, index) => {

    //     requirements.propertys.forEach(
    //       (propertys) => {
    //         propertys.items.forEach((item) => {

    //           reqPrice.push((item.num || 1) * (item.price || 0) * (requirements.num || 1));
    //         })
    //       }
    //     )
    //   }
    // )
    if (reqPrice.length) { // 如果有选中特殊要求
      reqPrice.sort((a, b) => a - b);
      let reqFee = reqPrice.reduce((accumulator, currentValue) => computePrice(accumulator + currentValue));
      totalProductPrice += reqFee;
      // pro.products.totalProductPrice = pro.price + reqFee;
    }
  }
  totalPrice = totalMealFee + totalProductPrice;
  console.log('价格计算：', totalPrice, totalMealFee, totalProductPrice);
  return {
    totalPrice:computePrice(totalPrice),
    totalMealFee:computePrice(totalMealFee),
    totalProductPrice:computePrice(totalProductPrice),
  }
}
const createProduct = (pro)=>{
  return {
    "pid":pro.uid,
    "typeId":pro.smallTypeId || pro.bigTypeId,
    "num":pro.num,
    "name":pro.name,
    "isScore":pro.isScore||false,
    "listRequirements":pro.listRequirements||[],
    "isCombination":pro.isCombination||false,
    "combinationId":pro.combinationId||0,
    "groups":pro.groups||[],
    "totalMealFee":pro.totalMealFee,
    "totalPrice":pro.totalPrice,
    "totalProductPrice":pro.totalProductPrice,

    ...pro
  };
}
export const mutations = {
  /**
    * 批量处理餐品
    * params keys {Array|object} 
    *  - array: 由购物车餐品的key（products._key）组成的数组，传该参数过来则是删除
    *  - object: 字段名由购物车餐品的key（products._key）组成的对象，传该参数过来则是添加或修改（如果已有该key的对象则是修改）
  */
  batchProcessingProMuta(state, keys) {
    if (Array.isArray(keys)) {
      let i = 1;
      keys.forEach((key) => {
        if (i > 0) {
          i = 0;
          if (typeof key === 'string' && state.products[key]) {
            let index = state.products[key].products._getIndex;
            if (index && state._products[index]) {
              state._products.splice(index, 1);
            }
            delete state.products[key];
          }
        }
      });
    } else if (typeof keys === 'object') {
      for (let key in keys) {
        state.products[key] = keys[key];
        this.dispatch('afterUpdatePro',key)
      }
    }
  },
  /**
    * 购物车如果有当前添加的餐品组合，则合并
    * param products {object} 餐品对象
    */
  changeCombination(state, products) {
    let statePro = state.products[products._key];
    statePro.num += products.num;
    statePro.products.num += products.products.num;
    products.products.listRequirements.forEach((item) => { statePro.products.listRequirements.push(item) });
    statePro.listRequirements = statePro.products.listRequirements;
  },
  /**
    * 添加套餐到购物车
    * param data {object} 套餐对象
    */
  groupsManage(state, data) {
    if (state.products[data._key] === undefined) { // 购物车是否存在该餐品
      productsManage.addItem(state, data._means || { _means: { getPath: '_products[' + state._products.length + ']' } }, data);
      state.products[data._key] = data;
    } else {
      if (data._means) {
        productsManage.changeItem(state, data, data);
      } else if (data._getIndex >= 0) {
        state._products.splice(data._getIndex, 1, data);
        // state._products[data._getIndex] = data;
      }
      state.products[data._key] = data;
      if (data.products) {
        for (let key in data.products) {
          if (data[key] !== undefined && key !== '_means') {
            data.products[key] = data[key];
          }
        }
      }
    }
  },
  /**
    * 改变某个餐品对象的值
    * param params {object} 套餐对象
      - type: 需要进行修改的类型 value: add || set || del || change;
      - oldObj: 需要修改的对象
      - obj: 需要修改的对象的新值，
        type type为change时改变使用 assgin({}, oldObj, obj) type为set替换改oldObj
      - key: 需要改变对象的某个字段名，type为add和set使用 提供的话则改变oldObj对象里某个字段值 如 key = a , oldObj.a = obj
    */
  changProductItem(state, params) {
    let oldObj = params.oldObj;
    let obj = params.obj;
    let key = params.key;
    switch (params.type) {
      case 'add':
        productsManage.addItem(state, oldObj, obj, key || '');
        break;
      case 'set':
        productsManage.setItem(state, oldObj, obj, key || '');
        break;
      case 'del':
        productsManage.delItem(state, oldObj);
        break;
      case 'change':
        productsManage.changeItem(state, oldObj, obj);
        break;
    }
    if (params.oldObj.products) {
      for (let key in params.oldObj.products) {
        if (params.oldObj[key] !== undefined && key !== '_means') {
          params.oldObj.products[key] = params.oldObj[key];
        }
      }
    }
  },
  /**
    * 改变某个餐品对象的特殊要求
    */
  changeRequirementItem(state, params) {
    productsManage.reqChange(state, params);
  },
  update(state,data){
    for(var key in data){
			if(typeof state[key]!=='undefined'){
				state[key] = data[key];
			}
		}
  },
  updateProductsByCartProducts(state, cartPros = []) {
    for(let key in state.products){
      let cartPro = cartPros.find(cartPro => cartPro._key === key)
      if(cartPro) {
        state.products[key].originIsChange = cartPro.originIsChange || false; // 接口定义 faultTolerantProductUpdateMealFee
      }
    }
  },
  updateFee(state,fee){
    if(fee){
      if (fee.manualDiscount) { // manualDiscount： 手动打折，如果需要另外的优惠则添加manualDiscount字段
        fee.manualDiscount = fee.manualDiscount > 0 ? 0 - fee.manualDiscount : fee.manualDiscount;
      }
      for(var key in fee){
        if(key !== 'total'){
          state.fee[key] = computePrice( fee[key] );
        }
      }
    }
    
    var feeArray = [];
    for(var key in state.fee){
      if(key !== 'total' && key !== 'surchargeRate' && key !== 'surcharge'){ // 忽略总金额和附加费字段
        feeArray.push(state.fee[key]);
      }
    }

    state.fee.total = computePrice(feeArray.reduce((p, c) => p + c));
    if (state.fee.surchargeRate) {
      let surcharge = computePrice((state.fee.total + Math.abs(state.fee.preferential) + Math.abs(state.fee.coupon)) * (state.fee.surchargeRate / 100));
      state.fee.total = computePrice(state.fee.total + surcharge); // 算上附加费
      state.fee.surcharge = surcharge;
    }

  },

  updateCoupon(state,coupon){
    state.coupon = coupon;
    this.dispatch("booking/order/update",{couponId : (coupon && coupon.couponId)?coupon.couponId:0});
  },
  proPush (state, pro) {
    // if(pro.isGroup){

    // }else if(pro.isRequirement){

    // }else{
      
    // }
    state.products[pro._key] = pro;

  },
  proUpdate(state, pro={}) {
    if(!pro || !pro._key){
      return false;
    }
    var tarPro = state.products[pro._key];
    if(!tarPro){
      return false;
    }

    let index = state.products[pro._key]._getIndex;
    if (!state._products[index] || state._products[index]._key !== pro._key) { // 防止删错商品
      index = state._products.findIndex((item) => item._key === pro._key);
    }
    // 如果有特殊要求
    if (tarPro.isRequirement && state._products[index].listRequirements) {
      if (pro.listRequirements) { // 如果传入了一个listRequirements对象则替换该对象
        state._products[index].listRequirements = pro.listRequirements;
      } else {
        let listRequirements = state._products[index].listRequirements;
        let reqLength = listRequirements.length;
        let num = 0;
        if (tarPro.num - pro.num > 0 || pro.num === 0) { // 判断当前操作是加是减
          if (listRequirements[reqLength - 1].num > pro.num) {
            num = listRequirements[reqLength - 1].num = listRequirements[reqLength - 1].num - pro.num;
          } else { // 如果特殊要求数量不满足则循环减掉特殊要求直到满足数量
            num = tarPro.num - pro.num;
            while (num !== 0) {
              if (listRequirements[reqLength - 1].num > num) {
                listRequirements[reqLength - 1].num -= pro.num;
                num -= listRequirements[reqLength - 1].num;
              } else {
                let reqNum = listRequirements.pop().num;
                num -= reqNum;
                reqLength = listRequirements.length;
              }
            }
            state._products[index].listRequirements = listRequirements;
          }
        } else {
          if (pro.reqIndex !== undefined) { // 特殊要求在输入框写入份数的时候
            let tmpNum = listRequirements[pro.reqIndex].num;
            num = listRequirements[pro.reqIndex].num = pro.num - tarPro.num;
            pro.num -= tmpNum; // 减去原来自己的那份
          } else {
            num = pro.num - tarPro.num;
            if (tarPro.requirements) {
              let addData = productsManage.requirementsManager.addRequirements(
                tarPro.requirements,
                state._products[index].listRequirements,
                num
              );
              listRequirements.push(addData);
            }
          }
        }
      }
    }

    for(var key in pro){
      tarPro[key] = pro[key];
    }

  },
  afterUpdatePro(state,_key){
    var pro = state.products[_key];
    if(pro && (!pro.num||pro.num<1)){
      delete state.products[_key];
      state.products = {...state.products};
    }else if(pro){
      var _pro;
      if (
        pro.groups
        && pro.groups.length
        && pro.totalPrice >= 0
        && pro.totalProductPrice >= 0
        && pro.totalMealFee >= 0
      ) { // 判断是否是套餐，套餐自己计算金额
        _pro = {
          totalPrice: pro.totalPrice,
          totalProductPrice: pro.totalProductPrice,
          totalMealFee: pro.totalMealFee
        }
      } else {
        _pro = computeProduct(pro);
      }
      for(var key in _pro){
        pro[key] = _pro[key];
        if (pro.products) {
          pro.products[key] = _pro[key];
        }
      }
    }


  },

  updateCommon(state){

    /**
     * 校验 && 重新计算购物车公用数据
     */

    var count_total = 0;
    
    //reset
    for(var key in state.count.big){
      state.count.big[key] = 0;
    }
    for(var key in state.count.small){
      state.count.small[key] = 0;
    }

    var fee_products = 0,
        fee_mealFee = 0,
        fee_total = 0;

    var hasProDelete = false;

    var count_product = {};
    var count_mealFee = 0;
    
    let isAmendNNew = this.state.booking.user.newAmend && this.state.booking.user.orderAmend.isAmend
    if(isAmendNNew) {
      fee_products += amendHelp.countProductFee(state.outMenuProducts);
      fee_products += amendProductFee.countGiveProductsFee(state.giveProducts);

      count_total += amendHelp.countProductCount(state.outMenuProducts);
    }
    

    //开始计算餐品相关
    for(var key in state.products){
      //检验
      if(!state.products[key].num){

        hasProDelete = true;
        delete state.products[key];
        
        if(typeof state.count.product[key] !=='undefined'){
          delete  state.count.product[key];
        }

        continue;
      }
      count_product[key] = state.products[key].num;;

      count_total += state.products[key].num;

      var smallTypeId = state.products[key].smallTypeId,
          bigTypeId = state.products[key].bigTypeId;

      if(typeof state.count.big[bigTypeId] == 'undefined'){
        state.count.big[bigTypeId] = 0;
      }
      if(smallTypeId !== 0 && typeof state.count.small[bigTypeId+"-"+smallTypeId] == 'undefined'){
        state.count.small[bigTypeId+"-"+smallTypeId] = 0;
      }


      if(key.indexOf(bigTypeId+"-") === 0){
        state.count.big[bigTypeId] += state.products[key].num;
        if(smallTypeId !== 0 && key.indexOf(bigTypeId+"-"+smallTypeId+"-") === 0){
          state.count.small[bigTypeId+"-"+smallTypeId] += state.products[key].num;
        }
      }

      // if (state.products[key].isRequirement && state.products[key].products.listRequirements) { // 计算特殊要求费用
      //   let reqPrice = []
      //   state.products[key].products.listRequirements.forEach(
      //     (requirements) => {
      //       requirements.propertys.forEach(
      //         (propertys) => {
      //           propertys.items.forEach((items) => {
      //             reqPrice.push((items.num || 1) * (items.price || 0));
      //           })
      //         }
      //       )
      //     }
      //   )
      //   if (reqPrice.length) { // 如果有选中特殊要求
      //     reqPrice.sort((a, b) => a - b);
      //     let reqFee = reqPrice.reduce((accumulator, currentValue) => computePrice(accumulator + currentValue));
      //     state.products[key].totalProductPrice = state.products[key].price + reqFee;
      //     state.products[key].totalPrice =  state.products[key].totalMealFee + state.products[key].totalProductPrice;
      //     // state.products[key].products.totalProductPrice = state.products[key].price + reqFee;
      //   } else { // 如果没有选中特殊要求则重新计算一遍金额
      //     state.products[key].totalProductPrice = state.products[key].price * state.products[key].num;
      //     state.products[key].totalPrice =  state.products[key].totalMealFee + state.products[key].totalProductPrice;
      //     // state.products[key].products.totalProductPrice = state.products[key].products.price * state.products[key].products.num;
      //   }
      //   ['totalPrice', 'totalMealFee', 'totalProductPrice'].forEach(itemKey => { state.products[key].products[itemKey] = state.products[key][itemKey] });
      // }

      // count_total += state.products[key].totalPrice;

      fee_products += state.products[key].totalProductPrice;
      if(state.products[key].totalMealFee){
        fee_mealFee += state.products[key].totalMealFee;
        count_mealFee += state.products[key].num;
      }
      
      fee_total += state.products[key].totalPrice;

    }

    if(hasProDelete){
      //products 数据量比较大 所以需要按需重新赋值(有删的情况)
      state.products = {...state.products};
    }

    
    var newProducts = [];
    for(var key in state.products){
      if (state.products[key].products) {
        state.products[key].products.num = state.products[key].num;
        newProducts.push(state.products[key].products);
      } else if (state.products[key]._means) {
        newProducts.push(state.products[key]);
      } else {
        newProducts.push(createProduct(state.products[key]));
      }
      // newProducts.push(createProduct(state.products[key].products || state.products[key]));
      // newProducts.push(state.products[key].products || state.products[key]);
    }
    state._products = newProducts;

    state.count.product = {...count_product};
    state.count.mealFee = count_mealFee;

    state.count.total = count_total;
    for(var key in state.count.big){
      if(!state.count.big[key]){
        delete state.count.big[key];
      }
    }
    for(var key in state.count.small){
      if(!state.count.small[key]){
        delete state.count.small[key];
      }
    }

    //触发全局变动
    state.count = {...state.count};



    //计算外送费
    var delivery = 0;
    var storeData = eval(STORE);
    var orderData = eval(ORDER);
    state.fee.products = computePrice(fee_products);
    state.fee.mealFee = orderData.type === 3 ? 0 : computePrice(fee_mealFee);
    if (storeData.deliveryFee === undefined) {
      storeData.deliveryFee = storeData.fee || 0;
    }
    if (storeData && storeData.storeId && state.fee.products > 0) {
      if (storeData.deliveryFee > 0 && (orderData.type == 1 || orderData.type == 4)) {
        //外卖或外卖预约时须计算外送费
        if (storeData.deliveryCheapList && storeData.deliveryCheapList.length) {
          var deliveryCheapFee = 0;
          var deliveryCheapList = storeData.deliveryCheapList.filter(cheap => (cheap.deliveryType == 0 || cheap.deliveryType == orderData.type));
          for (var i = 0, l = deliveryCheapList.length; i < l; i++) {
            if (state.fee.products >= deliveryCheapList[i].deliveryCheapRequire &&
              deliveryCheapFee < deliveryCheapList[i].deliveryCheapFee
            ) {
              deliveryCheapFee = deliveryCheapList[i].deliveryCheapFee;
            }
          }
          delivery = storeData.deliveryFee - deliveryCheapFee;
          if (delivery < 0) {
            delivery = 0;
          }
        } else {
          delivery = storeData.deliveryFee;
        }
      }
    }
    // 如果是新改单逻辑，则直接取原订单
    if(isAmendNNew) {
      delivery = this.state.booking.preferential.orderData.deliveryFee
    }
    state.fee.delivery = computePrice(delivery);
  },


  clear(state){
    var temp = utils.clearObject(_state);
    // let unClearFields = ['outMenuCartPros', 'giveProducts'];
    let unClearFields = [];
    for(var key in temp){
      if(!unClearFields.includes(key)) {
        state[key] = temp[key];
      }
    }
    
  },


}

export const actions = {
  /**
    * 批量处理餐品
    * params keys {Array|object} 
    * array: 由购物车餐品的key（products._key）组成的数组，传该参数过来则是删除
    * object: 字段名由购物车餐品的key（products._key）组成的对象，传该参数过来则是添加或修改（如果已有该key的对象则是修改）
  */
  batchProcessingPro({ state, commit, dispatch }, keys) {
    commit('batchProcessingProMuta', keys);
    dispatch('updateCommon');
  },
  /**
    * 添加套餐对象到套餐
    * param data {object} 要改变的对象
      — param data {object} 套餐对象
      — param group {object} 请求返回的套餐对象
  */
  addGroups({ state, commit, dispatch }, data) {
    // if (data.isAdd) {
      
    // } else {
    //   let indexList = productsManage.changeGroupItem(data.data.groups);
    //   if (indexList.length) {
    //     indexList.sort((a, b) => a - b);
    //     indexList.forEach((index) => {
    //       data.data.groups.splice(index, 0, false);
    //     });
    //   }
    //   commit('groupsManage', data);
    //   dispatch('afterUpdatePro',data.data._key);
    // }
    // data.groups = data.groups.filter((item) => item); // 过滤groups数组为空的对象
    // if (!data._means && data.products) { // 如果缺少_means对象则递归添加
    //   data._means= {
    //     getPath: '_products[' +  state._products.length + ']'
    //   }
    //   let groups = data.groups;
    //   if (!data.groups._means) {
    //     data.groups._means= {
    //       getPath: '_products[' +  state._products.length + '].groups',
    //       groups: data.group
    //     }
    //   }
    //   for (let i = 0; i < groups.length; i ++) {
    //     let path = '_products[' +  state._products.length + ']';
    //     if (groups[i].mains._means) {
    //       groups[i].mains._means= {
    //         getPath: path + '.mains'
    //       }
    //     }
    //     if (groups[i].exArea._means) {
    //       groups[i].exArea._means= {
    //         getPath: path + '.exArea'
    //       }
    //     }
    //     // groups[i].mains.forEach((item, index) => {
    //     //   productsManage.groupManager.loaderGroupList(item, path + '.mains[' + index + ']');
    //     // });
    //     // productsManage.groupManager.loaderGroupList(groups[i].exArea, path + '.exArea');
    //   }
    // }
    if (!data.products) { // 是否是未格式化的餐品对象
      let products = {
        pid: data.uid,
        typeId: data.smallTypeId || data.typeId || data.bigTypeId || 0,
        num: data.num,
        isScore: data.isScore || false,
        title: data.name,
        titleEn: data.nameEn || data.name,
        price: data.price,
        remark: data.remark || '',
        groups: data.groups,
        _means: {
          getPath: '_products[' + state._products.length + ']'
        },
        getIndex: state._products.length
      };
      // if (!data._means) {
      //   data.products._means = {
      //     getPath: '_products[' + state._products.length + ']'
      //   }
      // }
      if (data.getIndex === undefined) {
        data.getIndex = state._products.length;
      }
      data.products = JSON.parse(JSON.stringify(products));
    }
    commit('groupsManage', data);
    if (data._key) {
      commit('afterUpdatePro', data._key);
    }
    dispatch('updateCommon');
  },
  /**
    * 改变某个餐品对象的值
    * param params {object} 套餐对象
      - type: 需要进行修改的类型 value: add || set || del || change;
      - oldObj: 需要修改的对象
      - obj: 需要修改的对象的新值，
        type type为change时改变使用 assgin({}, oldObj, obj) type为set替换改oldObj
      - key: 需要改变对象的某个字段名，type为add和set使用 提供的话则改变oldObj对象里某个字段值 如 key = a , oldObj.a = obj
    */
  changProductItem({ state, commit, dispatch }, params) {
    let path = params.oldObj._means && params.oldObj._means.getPath;
    if (path !== undefined && (path.indexOf('listPropertys') > 0 || path.indexOf('listRequirements') > 0)) {
      commit('changeRequirementItem', params);
    } else {
      commit('changProductItem', params);
    }
    let key = '';
    if (params.oldObj._key) {
      key = params.oldObj._key;
    } else if (params.oldObj._means) {
      const start = params.oldObj._means.getPath.indexOf('_products');
      const end = params.oldObj._means.getPath.indexOf(']');
      const path = params.oldObj._means.getPath.slice(start, end + 1);
      key = productsManage.getPath(state, path)._key || false;
    }
    if (key) {
      dispatch('afterUpdatePro', key);
    } else {
      dispatch('updateCommon');
    }
  },

  init({commit,state},data){

    //校验::如果餐单ID不一致 则需清空购物车
    if(data.menuId && state.menuId != data.menuId){
      commit("clear");
      commit("update",data);
    }
  },

  updateCommon({commit,dispatch,state}){
    if(timer){clearTimeout(timer);}
    timer = setTimeout(()=>{
      commit('updateCommon');
      commit('updateFee');
      this.dispatch('booking/order/update',{products:state._products})
    },100)

    
  },

  afterUpdatePro({commit,dispatch,state},_key){
    
    commit('afterUpdatePro',_key);

    dispatch('updateCommon');
    
  },
  /**
    * 添加餐品对象到购物车
    * param pro {object} 餐品对象需要添加的餐品对象
      - pro {
        num 默认数量为1，
        * _key {string} 格式化餐品的key 必传
        ...{ 请求回来的餐品数据或是套餐格式化好的数据 }
      }
  */
  doPlus({commit,state,dispatch},pro){
    debugger
    var tarPro = state.products[pro._key];
    var num = pro.num || 1;
    if(tarPro){
      if (tarPro.groups) { // 如果是套餐的情况下，则返回该套餐
        return Promise.resolve({ status: 'groups', data: JSON.parse(JSON.stringify(tarPro)) });
      }
      let params = {
        _key: pro._key,
        num: tarPro.num + num
      };
      if (tarPro.isRequirement && pro.reqIndex !== undefined) {
        params.reqIndex = pro.reqIndex;
      }
      if(pro.listRequirements) {
        params.listRequirements = utils.clearObject(pro.listRequirements);
      }
      commit('proUpdate', params);
    }else{
      let _pro; // 存储格式化好的餐品数据，存放在_products数组里的
      if (pro.isCombination) { // 如果是餐品组合
        _pro = JSON.parse(JSON.stringify(pro._means.foodCombination.product));
        let proKey = pro._key;
        if (pro.combinationId) {
          proKey = proKey.slice(0, proKey.lastIndexOf('-') + 1) + pro.combinationId;
        }
        _pro.products = pro;
        _pro.products._key = proKey;
        tarPro = utils.clearObject(_pro);
        tarPro.num = pro.num;
        tarPro._getIndex = state._products.length;
        tarPro._key = proKey;
        if (state.products[proKey] !== undefined) { // 如果在购物车上也有同样的餐品
          commit('changeCombination', tarPro);
          dispatch('afterUpdatePro',tarPro._key);
          return Promise.resolve({ status: true });
        }
      } else {
        tarPro = utils.clearObject(pro);
        tarPro.num = num;
        _pro = productsManage.addProperty({
          food: pro,
          num: num,
          typeId: pro.smallTypeId,
          index: state._products.length
        });
        if (_pro.status) {
          tarPro._means = {
            getPath: 'products[' + pro._key + ']'
          };
          tarPro._getIndex = state._products.length;
          _pro.products._key = pro._key;
          // _pro = _pro.products;
          tarPro.products = _pro.products;
          if (pro.listRequirements) {
            _pro.products.listRequirements = utils.clearObject(pro.listRequirements);
            tarPro.listRequirements = utils.clearObject(pro.listRequirements);
          }
        }
      }
      // Object.keys(tarPro).forEach((key) => { _pro[key] = tarPro[key] });
      commit('proPush', tarPro);
    }

    dispatch('afterUpdatePro',tarPro._key);
    return Promise.resolve({ status: true });
  },
  doMinus({commit,state,dispatch},pro){
    if(!pro || !pro._key){return ;}

    var tarPro = state.products[pro._key];

    tarPro && (()=>{
      
      var num = (pro.num&&pro.num>0)?(tarPro.num - pro.num):0;

      commit('proUpdate',{
        _key: pro._key,
        num : num
      })
  

    })();
    dispatch('afterUpdatePro',pro._key);

  },

  updateProductsByCartProducts({commit, state}, cartPros) {
    commit('updateProductsByCartProducts', cartPros);
  },

  /** 
    * 计算餐品折扣
    * param aftPrePrice {number} 优惠金额
    * param couponOffsetMoney {number} 优惠券抵消金额
    * praam manualDiscount {number} 手动打折金额
    * praam surcharge {number} 附加费用 百分之1-100
    */
  updateFee({commit,state},{ aftPrePrice, couponOffsetMoney, manualDiscount, surchargeRate, originOrderDiscount, }){
    const fee = {};
    if(aftPrePrice !== undefined){
      if(aftPrePrice<0){
        aftPrePrice = state.fee.products;
      }
      fee.preferential = aftPrePrice - state.fee.products;
    }

    if(couponOffsetMoney !== undefined){
      fee.coupon = 0 - couponOffsetMoney;
    }

    if (manualDiscount !== undefined) {
      fee.manualDiscount = manualDiscount;
    }

    if (surchargeRate !== undefined) {
      fee.surchargeRate = surchargeRate;
    }

    if (originOrderDiscount !== undefined) {
      fee.originOrderDiscount = originOrderDiscount;
    }

    if (Object.keys(fee).length) {
      commit('updateFee', fee);
    }

  },


  updateCoupon({commit,dispatch},_couponData){
    var couponData;
    if(_couponData){
      couponData = utils.clearObject(_couponData);
    }
    dispatch('updateFee',{couponData:couponData||false});
    commit("updateCoupon",couponData||{})
  },

  clear({commit}){
    commit('clear');
    this.dispatch("booking/order/update",{
      products:[],
      couponId:0,
      preferentials:[],

    });
  },

  getCartProducts({ state }, keys) {
    return new Promise((resolve, reject) => {
      if (state.products[keys]) {
        resolve(deepCopy(state.products[keys]))
      } else {
        reject(false);
      }
    });
  }
  
}



// WEBPACK FOOTER //
// ./../../store/booking/cart.js